export enum EditMode {
    ReadOnly,
    Create,
    Edit
}
